require([
    'jquery',
    'ch_ga',
    'filter/CourseRows',
    'ch_cookie',
    'semantic',
    'services',
    'jquery_address',
    'ch_semantic_wishlist',
    'ch_email_wishlist',
    'ch_maps',
    'ch_utils',
    'ch_header',
    'ch_scrollto',
    'ch_semantic_responsive',
    'ch_section_interest',
], function ($, ga, CourseRows) {
    var currentSection;
    var courseId;

    // run ga tracking immediately
    if (CH.isFirstVisit()) {
        ga(
            'send',
            'event',
            'Unsellable Inventory',
            'Landing On Course Page'
                + (!CH.isAcceptingEnrollments ? ' Unsellable' : ' Sellable'),
            classData.length,
            { nonInteraction: true }
        );
    }

    if (!CH.isAcceptingEnrollments) {
        ga(
            'send',
            'event',
            'Unsellable Inventory',
            'Course page unsellable',
            classData.length,
            { nonInteraction: true }
        );
    }

    function initPayPal() {
        var $pricePerSeatRaw = $('#paypalFormContainer input[name=price]');
        var $totalPriceRaw = $('#total-price-raw');
        var $discountTotal = $('#paypalFormContainer input[name=discount-total]');
        var $product = $._('product-id');

        function postSubmitForPayPal(details) {
            if (details.class_discount) {
                $pricePerSeatRaw.val(details.price);
                $totalPriceRaw.val(details.discount_price);
                $discountTotal.val(details.discount_price - details.price);
            } else {
                $pricePerSeatRaw.val(details.price);
                $totalPriceRaw.val(details.price);
                $discountTotal.val(0);
            }

            $product.val(details.id);
        }

        require(['ch_paypal'], function () {
            CH.Paypal.init(function () {
                postSubmitForPayPal(currentSection || classData[section]);
            });
        });
        updatePayPal(currentSection);
    }

    function initSidebar() {
        // handle chat with us!
        $('.olark-open').click(function (e) {
            e.preventDefault();
            olark('api.box.expand');
        });
    }

    function initReviews() {
        // Course reviews
        var additional_course_reviews = $('#additional-course-reviews');
        var see_more_course_reviews = $('#see-more-course-reviews');
        var course_review_loader = $('#course-review-loader');
        var has_loaded_additional_course_reviews = false;

        // Provider reviews
        var additional_provider_reviews = $('#additional-provider-reviews');
        var see_more_provider_reviews = $('#see-more-provider-reviews');
        var provider_review_loader = $('#provider-review-loader');

        // Others
        var hide_more_reviews = $('#hide-more-reviews');
        var last_visible_review;
        hide_more_reviews.hide();
        course_review_loader.hide();
        provider_review_loader.hide();

        // Send GA event for review counts
        var reviewCount = $('.js-course-review-item').length;
        ga('send', 'event', 'reviews', (reviewCount < 1 ? '=0 reviews' : '>0 reviews'), {
            nonInteraction: true,
        });

        // Logic for displaying more provider reviews
        if (see_more_provider_reviews.length > 0) {
            see_more_provider_reviews.unbind('click').on('click', function (e) {
                e.preventDefault();

                see_more_provider_reviews.hide();
                provider_review_loader.show();

                $.ajax({
                    type: 'GET',
                    url: '/course/course/get-additional-reviews',
                    dataType: 'html',
                    data: {
                        course_id: courseId,
                        is_for_provider_review: true,
                    },
                    success: function (html) {
                        additional_provider_reviews.append(html);
                        additional_provider_reviews.slideDown('fast');
                        see_more_provider_reviews.hide();
                        hide_more_reviews.show();
                        provider_review_loader.hide();

                        see_more_provider_reviews.unbind('click').on('click', function (e) {
                            e.preventDefault();
                            additional_provider_reviews.slideDown('fast');
                            $(this).hide();
                            hide_more_reviews.show();
                        });
                    },
                });
            });

            if (see_more_course_reviews.length > 0) {
                see_more_provider_reviews.hide();
            }
        }

        // Logic for displaying more course reviews
        if (see_more_course_reviews.length > 0) {
            see_more_course_reviews.unbind('click').on('click', function (e) {
                e.preventDefault();
                see_more_course_reviews.hide();

                if (has_loaded_additional_course_reviews) {
                    additional_course_reviews.slideDown('fast');

                    if (CH.provider_review_count > 0) {
                        see_more_provider_reviews.show();
                    } else {
                        hide_more_reviews.show();
                    }
                } else {
                    course_review_loader.show();
                    $.ajax({

                        type: 'GET',
                        url: '/course/course/get-additional-reviews',
                        dataType: 'html',
                        data: {
                            course_id: courseId,
                        },
                        success: function (html) {
                            additional_course_reviews.append(html);
                            additional_course_reviews.slideDown('fast');
                            see_more_course_reviews.hide();
                            has_loaded_additional_course_reviews = true;

                            if (CH.provider_review_count > 0) {
                                see_more_provider_reviews.show();
                            } else {
                                hide_more_reviews.show();
                            }

                            course_review_loader.hide();
                        },
                    });
                }
            });
        }

        // Logic for hiding reviews
        hide_more_reviews.unbind('click').on('click', function (e) {
            e.preventDefault();

            last_visible_review = has_loaded_additional_course_reviews
                ? additional_course_reviews.offset().top - 200
                : additional_provider_reviews.offset().top;

            CH.scrollTo(last_visible_review);
            additional_provider_reviews.slideUp();
            additional_course_reviews.slideUp();
            $(this).hide();

            if (has_loaded_additional_course_reviews) {
                see_more_course_reviews.show();
            } else {
                see_more_provider_reviews.show();
            }
        });

        var $reviewBlock = $('#reviews-block');
        if ($reviewBlock.length) {
            var reviewOffset = $reviewBlock.offset().top;

            $(window).on('scroll.review_tracking', function (e) {
                var currentScrollBottom = $(window).scrollTop() + $(window).height();

                // At least one review is visible
                if (currentScrollBottom > (reviewOffset + 200)) {
                    $(window).off('scroll.review_tracking');
                    ga(
                        'send',
                        'event',
                        'reviews',
                        'Scrolled to at least one review',
                        classData.providerName + ': ' + classData.courseName,
                        { nonInteraction: true }
                    );
                }
            });
        }

        $('#see-more-course-reviews').on('click', function (e) {
            ga(
                'send',
                'event',
                'reviews',
                'Load more reviews on course page',
                classData.providerName + ': ' + classData.courseName,
                { nonInteraction: false }
            );
        });
    }

    function initCourseInfoTabs() {
        $('.item', '.js-course-info-tabs').tab({
            history: true,
            historyType: 'hash',
        });
    }

    // Set up the "Give as a Gift" Modal Window
    function initGiveAsGiftModal() {
        var ModalWindowGiveAsGiftObj = new ModalWindowGiveAsGift();

        $('.js-trigger-give-as-gc').click(function (e) {
            e.preventDefault();
            ga(
                'send',
                'event',
                'Gift Card Ads',
                'Course Main Button Clicked',
                null,
                { nonInteraction: false }
            );

            ModalWindowGiveAsGiftObj.show({
                onShow: function () {
                    updateCourseButtons(currentSection);

                    $('.js-enrollment-button', '#give-as-gift-window').on('click', function () {
                        ga(
                            'send',
                            'event',
                            'Gift Card Ads',
                            'Course Sub Buy Clicked',
                            window.location.href,
                            { nonInteraction: false }
                        );
                    });

                    $('.js-buy-a-gift', '#give-as-gift-window').on('click', function () {
                        ga(
                            'send',
                            'event',
                            'Gift Card Ads',
                            'Course Sub Gift Clicked',
                            window.location.href,
                            { nonInteraction: false }
                        );
                    });
                },
            });
        });
    }

    /**
     * loads "more classes at provider" into course page
     */
    function initProviderMoreCourses() {
        var $moreClassesElement = $('.js-more-classes-at-this-school');
        if (typeof courseId !== 'undefined') {
            $.get('/course/course/more-classes?course_id=' + courseId, function (html) {
                $moreClassesElement.find('.content').prepend(html);
                $moreClassesElement.show();
            });
        }
    }

    /**
     * changeSection
     *
     * stuff to do when changing selection section
     *
     * @param sectionId
     */
    function changeSection(sectionId) {
        currentSection = classData[sectionId];

        updateCourseLocation(currentSection);
        updateCourseMap(currentSection);
        updateCourseTeacher(currentSection);
        updateSessionsTimes(currentSection);
        updateCourseDetailsSeats(currentSection);
        updateCourseDetailsStartDate(currentSection);
        updateCourseNotes(currentSection);
        updateCourseDetailsPrice(currentSection);
        updateCourseButtons(currentSection);
        updatePayPal(currentSection);

        initScrollTos();
    }

    /**
     * updatePayPal
     *
     * show paypal button for all courses, except:
     *  when the class is free
     *  info sessions (any type)
     *
     * @param section
     */
    function updatePayPal(section) {
        $('.js-pay-with-paypal-section').toggle(
            section
            && section.price > 0
            && !section.isTypeOfInfoSession
        );
    }

    function initAdditionalSections() {
        // additional sections section
        $('.section-checkbox').checkbox({
            onChange: function () {
                var sectionId = $(this).val();
                changeSection(sectionId);
                $('#book-or-leadgen-section').val(sectionId);
            },
        });

        $('.js-select-radio').on('click', function () {
            var checkbox = $(this).parent().find('.checkbox');
            if (checkbox.length > 0) {
                checkbox.checkbox('check');
            }
        });
    }

    // Updates the box next to the class times table
    function updateCourseLocation(details) {
        var newLocation = '';

        if (CH.isOnline && details.address_name) {
            newLocation = details.address_name;
        } else if (details.formatted_address) {
            newLocation = details.formatted_address;
        }

        $('.section-location-text').html(newLocation);
        $('.section-info-address').html(newLocation);
        $('.js-class-location-text').html(newLocation);

        $('.js-course-detail-location').toggle(currentSection.type != 'Private Info Session');
    }

    // Updates the map location on the map tab
    function updateCourseMap(details) {
        var newMapUrl = details.map_url;
        var $mapContainer = $('.google-map');

        if ($mapContainer.attr('src') != newMapUrl) {
            $mapContainer.attr({
                src: newMapUrl,
            });
        }
        CH.map = details.geo_point;
    }

    // Updates the course teacher under the class description tab
    function updateCourseTeacher(details) {
        var teacher = details.teacher;
        if (
            teacher
            && (
                teacher.name
                || (
                    teacher.first_name
                    && teacher.last_name
                )
            )
        ) {
            var newTeacherName = teacher.name || teacher.first_name + ' ' + teacher.last_name;
            var newTeacherUri = '/'
                + CH.Hub.uri
                + '/teachers/'
                + details.teacher_category
                + '/'
                + teacher.uri;

            var teachLink = $('.section-teacher-name-link');
            $('.section-teacher').show();
            teachLink.attr('href', newTeacherUri);
            teachLink.html(newTeacherName);
        } else {
            $('.section-teacher').hide();
        }
    }

    /**
     * refresh "other sessions" listed in the course details and section table
     *
     * @param details
     */
    function updateSessionsTimes(details) {
        var courseInfoSchedules = [];
        var timeZoneString = CH.isOnline ? ' ET' : '';

        $.each(details.schedules, function (id, schedule) {
            courseInfoSchedules.push(schedule.formatted_string + timeZoneString + '<br>');
        });

        var otherSessions = '('
            + details.schedules.length
            + (details.schedules.length > 1 ? 'sessions' : 'session')
            + ')';

        $('.sections-schedules').html(courseInfoSchedules);
        $('.other-sessions-link').html(otherSessions);
    }

    // Updates the course price in the course details
    function updateCourseDetailsPrice(details) {
        var newPrice = '<span>' + details.price_string + '</span>';
        var newDiscountedPrice = '<span>' + details.discounted_price_string + '</span>';
        var $courseInfoPrice = $('.course-info-price');

        if (details.type == 'Info Session') {
            $courseInfoPrice.removeClass('deal');
            $('.original-price', $courseInfoPrice).html('<span>Free Info Session</span>');
        } else if (details.type == 'Private Info Session') {
            $courseInfoPrice.removeClass('deal');
            $('.original-price', $courseInfoPrice).html('<span>Free Private Info Session</span>');
        } else if (details.class_discount) {
            $courseInfoPrice.addClass('deal');
            $('.original-price', $courseInfoPrice).html(newPrice);
            $('.deal-price', $courseInfoPrice).html(newDiscountedPrice);
        } else {
            $courseInfoPrice.removeClass('deal');
            $('.original-price', $courseInfoPrice).html(newPrice);
        }
    }

    /**
     * updateCourseDetailsSeats
     *
     * Updates the seats available in the course details
     *
     * @param   Object    sectionDetails
     */
    function updateCourseDetailsSeats(sectionDetails) {
        var availableSeatCount = sectionDetails.available_seats;
        var isLowSeats = false;
        var $availableSeats = $('.course-info-seats-remaining');

        if (classData.isCouplesClass) {
            availableSeatCount *= classData.seatsPerEnrollment;
            isLowSeats = availableSeatCount <= 5 * classData.seatsPerEnrollment;
        } else {
            isLowSeats = availableSeatCount <= 5;
        }

        $availableSeats.toggleClass('low-seats', isLowSeats);

        $availableSeats.html(
            availableSeatCount
            + (availableSeatCount === 1 ? ' seat' : ' seats')
            + (CH.isLeftInSeatsLeftDisplayed ? ' left' : '')
        );
    }

    // Updates the course details start date above the quick navigation bar
    function updateCourseDetailsStartDate(details) {
        var $courseDetails = $('.course-details');
        var $classDateTime = $('.class-datetime', $courseDetails);
        var $otherSessions = $('.other-sessions', $courseDetails).hide();
        var timeZoneString = CH.isOnline ? ' ET' : '';
        var newSessionsHtml;

        $classDateTime.html(details.first_schedule_formatted_string + timeZoneString);

        if (details.sessions_count > 1) {
            // sometimes we remove it, sometimes it's just hidden, so we have to re-add
            if (!$otherSessions.length) {
                $otherSessions = $('<span class="other-sessions"></span>');
                $classDateTime.after($otherSessions);
            }

            $otherSessions
                .html(
                    ' (<a href="#" class="js-scroll-to other-sessions-link" data-target="#course-start-dates, #new-course-start-dates-layout">'
                    + details.sessions_count + (details.sessions_count == 1 ? ' session' : ' sessions')
                    + '</a>)'
                )
                .show();
        }
    }

    // Updates the course notes
    function updateCourseNotes(details) {
        if (details.notes) {
            $('.js-class-notes').show();
            $('.js-section-notes').html(details.notes);
        } else {
            $('.js-class-notes').hide();
        }

        $('.course-points').html(details.points + ' points');
    }

    // Updates the Book Now buttons at the top and bottom
    function updateCourseButtons(details) {
        // all enrollment buttons (warning: includes some in modals ie: give as gift)
        $('.js-enrollment-button').attr({
            href: CH.checkoutUrlPrefix + details.id,
            'data-js-schedule-id': details.id,
        });

        // all give giving buttons
        $('.js-trigger-give-as-gc, #give-as-gift-window .js-buy-a-gift')
            .attr('href', '/gift-card?schedule=' + details.id);
    }

    // @todo - refactor to simplify; no need to use "redux" principles here
    function initCarousel(imagesLength) {
        // State and it's initial value
        var _state = { activeIndex: 0 };

        // Dom elements used
        var $carouselContainer = $('#carousel-container');
        var $carouselContainerImg = $('#carousel-container-image');
        var $mainImgArrowLeft = $('#carousel-img-arrow-left');
        var $mainImgArrowRight = $('#carousel-img-arrow-right');
        var $imgCircles = $('#carousel-img-circles');

        var renderState = function (state) {
            var activeIndex = state.activeIndex;
            var direction = state.direction;

            // performs the UI changes to swap carousel
            var swapCarouselImage = function (src, direction) {
                // TODO: could put some fancy slide effect w/ direction, maybe .slideToggle?
                $carouselContainerImg.attr('src', src);
            };

            _state = state; // Keep our _state variable updated

            // set all circles to hollow
            $imgCircles.find('i.active')
                .removeClass('active')
                .addClass('outline');

            // fill in the activeIndex'th one
            $($imgCircles.find('i')[activeIndex]).addClass('active').removeClass('outline');

            // set all arrows to active
            $carouselContainer.find('.carousel-img-arrow.deactivated')
                .removeClass('deactivated').removeAttr('disabled');

            // disable arrow if we're at 0 or max
            if (activeIndex === 0) {
                $mainImgArrowLeft.addClass('deactivated').attr('disabled', 'disabled');
            }

            if (activeIndex === (imagesLength - 1)) {
                $mainImgArrowRight.addClass('deactivated').attr('disabled', 'disabled');
            }

            if (CH && CH.carouselTitleImages) {
                swapCarouselImage(CH.carouselTitleImages[activeIndex], direction);
            }
        };

        // Following principals of redux, creating a function that takes state and action and returns newState
        var reducer = function (state, action) {
            ga(
                'send',
                'event',
                'Course Page - Carousel',
                action.type,
                action.direction || action.newIndex,
                { nonInteraction: true }
            );

            var currentIndex = state.activeIndex;
            if (action.type === 'direction') {
                if (action.direction === 'left') {
                    currentIndex--;
                } else if (action.direction === 'right') {
                    currentIndex++;
                }

                if (currentIndex >= imagesLength) {
                    currentIndex = imagesLength;
                }

                if (currentIndex < 0) {
                    currentIndex = 0;
                }
            } else if (action.type === 'set') {
                currentIndex = action.newIndex;
            }

            return {
                activeIndex: currentIndex,
                direction: (currentIndex < state.activeIndex) ? 'left' : 'right',
            };
        };

        // Handlers
        var imgArrowClicked = function (direction) {
            renderState(reducer(_state, { type: 'direction', direction: direction }));
        };

        $mainImgArrowRight.on('click', imgArrowClicked.bind(null, 'right'));
        $mainImgArrowLeft.on('click', imgArrowClicked.bind(null, 'left'));
        $imgCircles.find('i').on('click', function (e) {
            var newIndex = Number($(e.target).attr('data-js-index'));
            renderState(reducer(_state, { type: 'set', newIndex: newIndex }));
        });
    }

    function initMosaicPhotoLayout() {
        var $mosaicPhotoLayoutGrid = $('#mosaic-photo-layout-grid');
        var $mosaicModal;
        var $mosaicModalImage;

        if ($mosaicPhotoLayoutGrid.length) {
            $mosaicModal = $('#mosaic-modal');
            $mosaicModalImage = $('#mosaic-modal-image');

            require(['collageplus'], function () {
                // Start collage library
                $mosaicPhotoLayoutGrid.collagePlus(
                    {
                        targetHeight: 200,
                        padding: 10,
                    }
                );

                $mosaicPhotoLayoutGrid.find('img').unbind('click').on('click', function () {
                    $mosaicModalImage.attr(
                        'src',
                        this.src
                    ).on('load', function () {
                        $mosaicModal.modal('show');
                    });

                    ga(
                        'send',
                        'event',
                        'MosaicPhotoLayout',
                        'Mosaic Photo Clicked',
                        null,
                        {
                            nonInteraction: false,
                        }
                    );
                });

                $mosaicPhotoLayoutGrid.removeClass('invisible');
            });
        }
    }

    // @todo cleanup after CH-6418
    function initNewSectionLayout() {
        var $tables = $('#new-course-start-dates-layout .ui.table');
        var $paginator = $('#section-pagination-container .item').not('.icon');
        var $paginatorUpDownNavigation = $('#section-pagination-container .icon.item');
        var $sectionRows = $tables.find('.section-row');
        var activePaginationNumber = CH.activePaginationNumber;

        // get currently selected row (can't trust "selected" class)
        var $selectedSectionRow = $sectionRows.has('input:checked');

        // initialize selected row
        $sectionRows.removeClass('selected');
        $selectedSectionRow.addClass('selected');

        // Actually perform the pagination action
        function tableTransition(currentActiveNumber) {
            var newActiveItemNumber;

            switch (currentActiveNumber) {
            case 'up':
                newActiveItemNumber = activePaginationNumber + 1;
                break;
            case 'down':
                newActiveItemNumber = activePaginationNumber - 1;
                break;
            default:
                newActiveItemNumber = parseInt(currentActiveNumber);
                break;
            }

            var $newActiveTable = $tables[newActiveItemNumber];
            var $newActivePaginatorItem = $paginator[newActiveItemNumber];
            if ($newActiveTable && $newActivePaginatorItem) {
                // Update table
                $tables.hide();
                $($newActiveTable).show();
                // Update paginator
                $paginator.removeClass('active');
                $($newActivePaginatorItem).addClass('active');
                // Update current page number
                activePaginationNumber = newActiveItemNumber;
                // Update navigation icons
                $paginatorUpDownNavigation.show();
                if (activePaginationNumber === 0) {
                    $($paginatorUpDownNavigation[0]).hide();
                } else if (activePaginationNumber === ($paginator.length - 1)) {
                    $($paginatorUpDownNavigation[1]).hide();
                }
            }
        }

        /**
         * 1) Triggers a table transition
         * 2) Triggers an update on the paginator itself
         */
        $('#section-pagination-container .item').unbind('click').on('click', function () {
            tableTransition($(this).data('value'));

            ga('send', 'event', 'new section layout', 'clicked on pagination', {
                nonInteraction: false,
            });
        });

        /**
         * 1) Shows other section rows
         * 2) Updates chevron
         */
        $('.view-other-sections-row').unbind('click').on('click', function () {
            var $self = $(this);
            var sectionId = $self.attr('id');
            var $chevron = $self.find('.view-more-chevron');
            var $otherSections = $tables.find('.' + sectionId);

            ga('send', 'event', 'new section layout', 'clicked view other sections row', {
                nonInteraction: true,
            });

            if ($otherSections.is(':visible')) {
                $otherSections.hide();
                $chevron.removeClass('up').addClass('down');
            } else {
                $otherSections.show();
                $chevron.removeClass('down').addClass('up');
            }
        });

        /**
         * 1) Highlights section row
         * 2) Shows view other sections row if applicable
         * 3) Highlights other sections rows if applicable
         */
        $sectionRows.unbind('click').on('click', function () {
            var $newSelectedSectionRow = $(this);
            var sectionId = $selectedSectionRow.data('section-id');
            var $viewOtherSectionsRow = $('#' + sectionId);
            var $otherSectionRows = $tables.find('.' + sectionId);
            var $radioButton = $newSelectedSectionRow.find('.ui.radio.checkbox');

            // Prevent same click on row
            if (sectionId === $newSelectedSectionRow.data('section-id')) {
                return false;
            }

            ga('send', 'event', 'new section layout', 'change section row', {
                nonInteraction: true,
            });

            // Handle currently selected row
            $viewOtherSectionsRow.hide();
            $otherSectionRows.hide();
            $otherSectionRows.toggleClass('selected');
            $selectedSectionRow.toggleClass('selected');

            // Handle new selected row
            sectionId = $newSelectedSectionRow.data('section-id');
            $viewOtherSectionsRow = $('#' + sectionId);
            $otherSectionRows = $tables.find('.' + sectionId);
            $radioButton.checkbox('check');
            $viewOtherSectionsRow.show();
            $otherSectionRows.toggleClass('selected');
            $newSelectedSectionRow.toggleClass('selected');

            // update course details
            changeSection(sectionId);

            // set current selected row
            $selectedSectionRow = $newSelectedSectionRow;
        });

        // Only function to trigger an event for this button
        $('#book-online-container .ui.button').on('click', function () {
            ga('send', 'event', 'new section layout', 'clicked book online button', {
                nonInteraction: true,
            });
        });

        // section id may not be available for a course w/ no sections
        var currentSectionId = $selectedSectionRow
            ? $selectedSectionRow.data('section-id')
            : null;

        // set currently selected section
        if (currentSectionId) {
            changeSection(currentSectionId);
            // navigate to section's  page
            tableTransition(activePaginationNumber);
        }
    }

    function initLearnMoreButton() {
        $('.js-learn-more-non-enrollment').on('click', function () {
            CH.showSectionInterestModal(
                currentSection.id,
                classData.courseName,
                classData.providerName
            );
        });
    }

    function initCoursePageEvents() {
        if (CH.isPrivate) {
            ga(
                'send',
                'event',
                'Private courses - course page',
                'Private course page visited',
                classData.courseName,
                { nonInteraction: false }
            );
        }

        if (classData.isCourseDatesDisplayed) {
            $('.js-school-site-button').on('click', function () {
                ga(
                    'send',
                    'event',
                    'Course Page',
                    'Checkout Offsite Clicked',
                    'Course Dates Displayed',
                    { nonInteraction: false }
                );
            });

            if (classData.isProviderCheckoutOffsite) {
                ga(
                    'send',
                    'event',
                    'Course Page',
                    'Checkout Offsite View',
                    'Course Dates Displayed',
                    { nonInteraction: true }
                );
            }
        } else {
            $('.js-school-site-button').on('click', function () {
                ga(
                    'send',
                    'event',
                    'Course Page',
                    'Checkout Offsite Clicked',
                    'Course Dates Not Displayed',
                    { nonInteraction: false }
                );
            });

            if (classData.isProviderCheckoutOffsite) {
                ga(
                    'send',
                    'event',
                    'Course Page',
                    'Checkout Offsite View',
                    'Course Dates Not Displayed',
                    { nonInteraction: true }
                );
            }
        }

        if (CH && CH.coursePage) {
            if (Number.isInteger(CH.coursePage.activeSectionCount)) {
                ga(
                    'send',
                    'event',
                    'Viewed Course Page',
                    'Available Sections',
                    CH.coursePage.activeSectionCount,
                    { nonInteraction: true }
                );
            }

            if (CH.coursePage.mainParentCategory) {
                ga(
                    'send',
                    'event',
                    'Viewed Course Page',
                    'Course Main Parent Category',
                    CH.coursePage.mainParentCategory,
                    { nonInteraction: true }
                );
            }

            if (CH.coursePage.leadCategory) {
                ga(
                    'send',
                    'event',
                    'Viewed Course Page',
                    'Course Lead Category',
                    CH.coursePage.leadCategory,
                    { nonInteraction: true }
                );
            }
        }
    }

    /**
     * initCommunityMessages
     *
     * Initialize all handlers and default behavior for the "community q&a" section
     *
     */
    function initCommunityMessages() {
        require(['mustache'], function (Mustache) {
            // function-wide variables
            var $communityMessagesContainer = $('.community-messages');
            var $questionsContainer = $('.community-messages-questions', $communityMessagesContainer);
            var $questionForm = $('#community-message-question-form', $communityMessagesContainer);
            var $button = $('.button', $questionForm);
            var $answerForms = $('.community-messages-answer-form');

            // function-wide templates
            var questionTemplate = $('#tmpl-community-messages-question').html();
            var answerTemplate = $('#tmpl-community-messages-answer').html();

            /**
             * User is considered "anonymous" when
             * they have no user, identity or name
             *
             * @returns {boolean}
             */
            function isUserAnonymous() {
                return !CH.isUserWithEmail
                    || !CH.isUserWithName;
            }

            /**
             * Ask user for additional info such as:
             * - sign in or sign up
             * - name
             *
             * @param $form
             * @param type      question|answer
             */
            function promptUserForAdditionalInfo(type, formCallback) {
                if (!CH.isUserWithEmail) {
                    ga(
                        'send',
                        'event',
                        'Course Page QA',
                        'Email Requested',
                        type,
                        { nonInteraction: false }
                    );

                    var ModalWindowRegObj = new ModalWindowRegister();
                    var ModalWindowLoginObj = new ModalWindowLogin();
                    var ModalWindowRegEmailObj = new ModalWindowRegisterEmail({
                        onLoad: function (window) {
                            var $modalWindow = $(window.window);
                            // customize the generic Reg By Email modal
                            $modalWindow.find('.facebook-sign-in').hide();
                            $modalWindow.find('.submit-button').val('Get Notified');
                            $modalWindow.find('.submit-no-thanks').html('No thanks, I\'ll check this page later for an answer');
                            $modalWindow.find('input[name=funnel]').val('Community QA');
                            $modalWindow.find('input[name=form_RegisterEmail_subscribe]')
                                .parentsUntil('.field')
                                .remove();
                        },
                    });

                    var modalInstanceOptions = {
                        onShow: function () {
                            var $modalWindow = $(this.window);
                            var $header;
                            var $description;
                            this.isShowing = true;
                            this.isCallbackRun = false;

                            // get the correct header element based on whether we've already manipulated it
                            if (!this.initialized) {
                                $header = $modalWindow.find('.ui.header');
                                $description = $modalWindow.find('.ui.description');
                                this.initialized = true;
                            } else {
                                $header = $modalWindow.find('.ui.success.message');
                                $description = $modalWindow.find('.ui.header');
                            }

                            if ($modalWindow.attr('id') == 'register-email-window') {
                                if (type == 'answer') {
                                    $header
                                        .removeClass()
                                        .addClass('ui success message')
                                        .html('Thanks! Your answer has been received.');
                                    $description
                                        .removeClass()
                                        .addClass('ui header')
                                        .html('Get notified of new answers and updates.');
                                } else {
                                    $header
                                        .removeClass()
                                        .addClass('ui success message')
                                        .html('Great! Your question has been received.');
                                    $description
                                        .removeClass()
                                        .addClass('ui header')
                                        .html('Get notified when an answer has been posted.');
                                }
                            } else {
                                $header.hide();
                                $description.hide();
                            }
                        },
                        onSuccess: function (res) {
                            var $modalWindow = $(this.window);

                            this.isCallbackRun = true;

                            if (res && res.data && res.data.email) {
                                CH.isUserWithEmail = true;
                            }
                            // see if user has a name, too
                            if (res && res.data && res.data.first_name) {
                                CH.isUserWithName = true;
                            }

                            ga(
                                'send',
                                'event',
                                'Course Page QA',
                                'Modal Submitted',
                                type + ' | ' + $modalWindow.attr('id'),
                                { nonInteraction: true }
                            );

                            formCallback();
                        },
                        onHide: function () {
                            var modalContext = this;
                            this.isShowing = false;
                            // stack this function behind other events/async callbacks (ie: modal hide/shows)
                            setTimeout(function () {
                                // onHide is called for every modal transition...
                                // don't trigger form callback until all modals are hidden
                                if (
                                    !ModalWindowRegObj.isShowing
                                    && !ModalWindowRegEmailObj.isShowing
                                    && !ModalWindowLoginObj.isShowing
                                    && !modalContext.isCallbackRun
                                ) {
                                    formCallback();
                                }
                            }, 0);
                        },
                    };

                    // modals triggering modals
                    ModalWindowRegEmailObj.link(ModalWindowLoginObj, {
                        instanceOptions: $.extend(
                            ModalWindowLoginObj.instanceOptions,
                            modalInstanceOptions
                        ),
                    });
                    ModalWindowLoginObj.link(ModalWindowRegObj, {
                        instanceOptions: $.extend(
                            ModalWindowRegObj.instanceOptions,
                            modalInstanceOptions
                        ),
                    });
                    ModalWindowRegObj.link(ModalWindowLoginObj, {
                        instanceOptions: $.extend(
                            ModalWindowLoginObj.instanceOptions,
                            modalInstanceOptions
                        ),
                    });

                    ModalWindowRegEmailObj.show(modalInstanceOptions);
                } else if (!CH.isUserWithName) {
                    ga(
                        'send',
                        'event',
                        'Course Page QA',
                        'Name Requested',
                        type,
                        { nonInteraction: false }
                    );

                    var ModalWindowUserDetailsObj = new ModalWindowUserDetails();

                    ModalWindowUserDetailsObj.show({
                        onShow: function () {
                            this.isCallbackRun = false;
                        },
                        onSuccess: function (res) {
                            this.isCallbackRun = true;
                            CH.isUserWithName = true;
                            ga(
                                'send',
                                'event',
                                'Course Page QA',
                                'Name Accepted',
                                type,
                                { nonInteraction: true }
                            );
                            formCallback();
                        },
                        onHide: function () {
                            // stack this function behind other events/async callbacks (ie: modal hide/shows)
                            setTimeout(function () {
                                // onHide is called for every modal transition...
                                // don't trigger form callback if it's already done so
                                if (!ModalWindowUserDetailsObj.isCallbackRun) {
                                    formCallback();
                                }
                            }, 0);
                        },
                    });
                } else {
                    formCallback();
                }
            }

            function submitQuestionForm($form, $questionsContainer, $button) {
                if ($form.data('isSubmitting')) {
                    return false;
                }

                $form.data('isSubmitting', true);
                $button.prop('disabled', true);
                $form.addClass('loading');

                $.ajax({
                    type: 'POST',
                    url: $form.attr('url'),
                    data: $form.serialize(),
                    complete: function () {
                        $form.removeClass('loading');
                        $button.prop('disabled', false);
                        $form.data('isSubmitting', false);
                    },
                    success: function (response) {
                        var $newQuestion;

                        if (response.success) {
                            ga(
                                'send',
                                'event',
                                'Course Page QA',
                                'Submit Accepted',
                                'question',
                                { nonInteraction: false }
                            );

                            $form.trigger('reset');
                            $questionsContainer.removeClass('empty');

                            $newQuestion = $(Mustache.render(
                                questionTemplate,
                                {
                                    author: response.data.abbreviatedName,
                                    body: response.data.body,
                                }
                            )).hide();

                            $questionsContainer.prepend($newQuestion);
                            $newQuestion.show('slow');
                        } else {
                            ga(
                                'send',
                                'event',
                                'Course Page QA',
                                'Submit Refused',
                                'question',
                                { nonInteraction: false }
                            );
                            $form.form('add errors', [
                                'There was a problem with your submission',
                                response.error,
                            ]);
                        }
                    },
                });
            }

            function submitAnswerForm($form, $answersContainer, $button) {
                if ($form.data('isSubmitting')) {
                    return false;
                }
                $form.data('isSubmitting', true);
                $button.prop('disabled', true);
                $form.addClass('loading');

                $.ajax({
                    type: 'POST',
                    url: $form.attr('url'),
                    data: $form.serialize(),
                    complete: function () {
                        $form.removeClass('loading');
                        $form.data('isSubmitting', false);
                        $button.prop('disabled', false);
                    },
                    success: function (response) {
                        var $newAnswer;

                        if (response.success) {
                            ga(
                                'send',
                                'event',
                                'Course Page QA',
                                'Submit Accepted',
                                'answer',
                                { nonInteraction: false }
                            );

                            $form.trigger('reset');

                            $newAnswer = $(Mustache.render(
                                answerTemplate,
                                {
                                    author: response.data.abbreviatedName,
                                    body: response.data.body,
                                }
                            )).hide();

                            $answersContainer.show().append($newAnswer);

                            // make the "show all answers" button padded for this guy to sit below it
                            $('.show-all-answers', $answersContainer).addClass('in-between');

                            $newAnswer.show('slow');

                            // hide the form
                            $form.slideUp('fast')
                                .siblings('.button.answer')
                                .slideDown('fast');
                        } else {
                            ga(
                                'send',
                                'event',
                                'Course Page QA',
                                'Submit Refused',
                                'answer',
                                { nonInteraction: false }
                            );
                            $form.form('add errors', [
                                'There was a problem with your submission',
                                response.error,
                            ]);
                        }
                    },
                });
            }

            function showAllQuestions() {
                $('.community-messages-question.hide', $communityMessagesContainer).slideDown();
                $('.show-all-questions', $communityMessagesContainer).slideUp();
            }

            /**
             * get the user label for ga events
             *
             * @returns {string}
             */
            function getUserTypeLabel() {
                var userType = 'anonymous';
                if (CH.isUserWithAccount) {
                    userType = 'registered';
                } else if (CH.isUserWithEmail) {
                    userType = 'email';
                }

                if (CH.isUserWithName) {
                    userType += ' | with name';
                } else {
                    userType += ' | no name';
                }
                return userType;
            }

            // track if the q&a area had content
            if ($questionsContainer.find('.community-messages-question').length > 0) {
                ga(
                    'send',
                    'event',
                    'Course Page QA',
                    'Content Includes Questions',
                    classData.providerName + ' | ' + classData.courseName,
                    { nonInteraction: true }
                );

                if ($questionsContainer.find('.community-messages-answer').length > 0) {
                    ga(
                        'send',
                        'event',
                        'Course Page QA',
                        'Content Includes Answers',
                        classData.providerName + ' | ' + classData.courseName,
                        { nonInteraction: true }
                    );
                }
            }

            // basic tracking: clicks on tabs
            $('a.item', '.js-course-info-tabs').on('click', function (e) {
                var clickedTab = $(this).data('tab');
                ga('send', 'event', 'Course Page Tabs', 'Clicked', clickedTab, { nonInteraction: false });
            });

            // when user clicks "add answer" button
            // then show the answer form
            $('.community-messages-questions .answer.button', $communityMessagesContainer).on('click', function (e) {
                e.preventDefault();
                ga('send', 'event', 'Course Page QA', 'Answer Form Displayed', 'click', { nonInteraction: false });
                $(this)
                    .slideUp('fast')
                    .parents('.community-messages-question')
                    .find('.community-messages-answer-form')
                    .slideDown('fast');
            });


            // when user clicks a cancel answer button
            // then hide the answer form
            $('.community-messages-answer-form .cancel.button', $communityMessagesContainer).on('click', function (e) {
                e.preventDefault();
                ga('send', 'event', 'Course Page QA', 'Answer Form Hidden', 'cancel', { nonInteraction: false });
                $(this)
                    .parents('.community-messages-answer-form')
                    .slideUp('fast')
                    .siblings('.button.answer')
                    .slideDown('fast');
            });

            // when user clicks to see all questions
            // then display all questions and remove self
            $('.show-all-questions', $communityMessagesContainer).on('click', function (e) {
                e.preventDefault();
                ga('send', 'event', 'Course Page QA', 'Show All Clicked', 'question', { nonInteraction: false });
                showAllQuestions();
            });

            // when user clicks to see all answers
            // then display all related answers and remove self
            $('.show-all-answers', $communityMessagesContainer).on('click', function (e) {
                e.preventDefault();
                ga('send', 'event', 'Course Page QA', 'Show All Clicked', 'answer', { nonInteraction: false });
                $(this).siblings('.community-messages-answer.hide').slideDown();
                $(this).slideUp();
            });

            // validation rules for "answers"
            $answerForms.form({
                fields: {
                    body: {
                        identifier: 'body',
                        rules: [
                            {
                                type: 'empty',
                                prompt: 'Please enter an answer',
                            },
                        ],
                    },
                },
            });

            // handle answer form submissions
            $answerForms.on('submit', function (e) {
                e.preventDefault();

                var $form = $(this);
                var $button = $form.find('input[type=submit]');
                var $answersContainer = $form.siblings('.community-messages-answers');
                var userTypeLabel = getUserTypeLabel();

                if ($form.form('is valid')) {
                    ga(
                        'send',
                        'event',
                        'Course Page QA',
                        'Answer Submitted',
                        userTypeLabel,
                        { nonInteraction: false }
                    );

                    if (isUserAnonymous()) {
                        promptUserForAdditionalInfo('answer', function () {
                            submitAnswerForm($form, $answersContainer, $button);
                        });
                    } else {
                        submitAnswerForm($form, $answersContainer, $button);
                    }
                }
            });

            // validation rules for "questions"
            $questionForm.form({
                fields: {
                    body: {
                        identifier: 'body',
                        rules: [
                            {
                                type: 'empty',
                                prompt: 'Please enter a question',
                            },
                        ],
                    },
                },
            });

            // handle question submissions
            $questionForm.on('submit', function (e) {
                e.preventDefault();

                var userTypeLabel = getUserTypeLabel();

                if ($questionForm.form('is valid')) {
                    ga(
                        'send',
                        'event',
                        'Course Page QA',
                        'Question Submitted',
                        userTypeLabel,
                        { nonInteraction: false }
                    );

                    // for all users
                    // if user is anon ask them to sign up
                    // if they say ok, trigger sign up flow
                    // otherwise submit normally
                    if (isUserAnonymous()) {
                        promptUserForAdditionalInfo('question', function () {
                            submitQuestionForm($questionForm, $questionsContainer, $button);
                        });
                    } else {
                        submitQuestionForm($questionForm, $questionsContainer, $button);
                    }
                }
            });

            // scroll to a specific community-message by id
            var locationHash = $(location).attr('hash');
            if (
                locationHash
                && /^#community-messages-([0-9])+$/.test(locationHash)
            ) {
                showAllQuestions();

                // note: browser default behavior should scroll down automatically
                // sometimes it doesn't trigger so we force it
                CH.scrollToElement($(locationHash));
            }
        }); // end require
    } // end initCommunityMessages

    function initBookOrLeadgen() {
        var $container = $('#book-or-leadgen');
        var $form = $('#leadgen-form');
        var $inquiryModal = $('#inquiry-modal');
        var sendMessageTimeout = null;

        if (!$form.length) {
            return;
        }

        /**
         * olark chat triggers
         *
         * - hide the modal
         * - show the chat window
         * - send a customized initial message to user based on which button they clicked
         * - track a ga() event
         */
        $('.js-trigger-olark').on('click', function (e) {
            var initialChatMessage = 'Hi there, how can I help? (I\'m a real person!)';

            e.preventDefault();
            olark('api.box.expand'); // api.box.expand
            $inquiryModal.modal('hide');
            // triggerSource can either be via a button ('trigger-source')
            // or it may be via the modal's "chat live" button, in which case we want to check
            // the button (innquiry type) they used to trigger the modal
            var triggerSource = $(this).data('trigger-source');

            if (!triggerSource && clickedTriggerInquiryType) {
                triggerSource = clickedTriggerInquiryType;
                if (clickedTriggerInquiryType.match(/Financial Aid/i)) {
                    initialChatMessage = 'Hi there, give me one second to pull up financing options for this class.';
                } else if (clickedTriggerInquiryType.match(/scheduling/i)) {
                    initialChatMessage = 'Hi there, give me one second to pull up scheduling options for this class';
                }
            }
            // clear it out
            clickedTriggerInquiryType = null;

            // tell operator what level of interest a user has
            olark('api.chat.sendNotificationToOperator', {
                body: 'User is interested in lead gen: ' + triggerSource,
            });

            // send the initial message to the user a little delayed so it looks "live"
            clearTimeout(sendMessageTimeout);
            sendMessageTimeout = setTimeout(function () {
                olark('api.chat.sendMessageToVisitor', {
                    body: initialChatMessage,
                });
            }, 1000);

            ga(
                'send',
                'event',
                'Leadgen',
                'Clicked Chat Button',
                classData.providerName
                + ': ' + classData.courseName
                + ' | ' + $container.data('leadgen-type')
                + ' | ' + triggerSource
            );
        });

        ga(
            'send',
            'event',
            'Leadgen',
            'Course with leadgen loaded',
            classData.providerName + ': ' + classData.courseName + ' | ' + $container.data('leadgen-type'),
            { nonInteraction: true }
        );

        // Keep section selector in sync with other section selectors on the page
        $('#book-or-leadgen-section').on('change', function () {
            var sectionId = $(this).val();
            changeSection(sectionId);
            var $checkboxInput = $('.section-checkbox[data-section-id=' + sectionId + ']');

            if ($checkboxInput.length > 0) {
                $checkboxInput.trigger('click');
            }
        });

        $('.ui.checkbox', $container).checkbox();

        // Set up tab UI
        $('.booking-menu .item').tab({
            history: true,
            historyType: 'hash',
        }).on('click', function (e) {
            var $me = $(this);
            if (!e.isTrigger) {
                ga(
                    'send',
                    'event',
                    'Leadgen',
                    'Book or leadgen tab clicked',
                    classData.providerName + ': ' + classData.courseName + ' | ' + $me.data('tab'),
                    { nonInteraction: true }
                );
            }
        });

        $.fn.form.settings.rules.phoneFormat = function (value) {
            var copy = value.replace(/[^0-9]/g, '').trim();
            return value.trim().length == 0 || /^\d{10,15}?$/.test(copy);
        };

        var emptyRule = {
            type: 'empty',
            prompt: 'This field is required.',
        };

        var formFields = {
            email: {
                rules: [
                    emptyRule,
                    {
                        type: 'email',
                        prompt: 'Please enter a valid email.',
                    },
                ],
            },
            full_name: {
                rules: [
                    emptyRule,
                ],
            },
            phone: {
                rules: [
                    {
                        type: 'checkContactMethodPreference',
                        prompt: 'Please provide a phone number',
                    },
                    {
                        type: 'phoneFormat',
                        prompt: 'This phone number format is invalid',
                    },
                ],
            },
        };

        var clickedTrigger = null;
        var clickedTriggerInquiryType = null;
        var $inquiryForm = $('#inquiry-info-form');
        $('.js-trigger-inquiry').on('click', function (e) {
            e.preventDefault();
            clickedTrigger = this;
            clickedTriggerInquiryType = $(this).data('inquiry-type');
            $('.booking-menu .item[data-tab=inquiry]', $container).trigger('click');
            $('[name="info_type[]"]').prop('checked', false);
            $('[value="' + clickedTriggerInquiryType + '"]', $form).prop('checked', true);
            $form.submit();
        });

        $('.js-inquiry-submit').on('click', function (e) {
            clickedTrigger = null;
        });

        // a custom validation rule:
        // make sure a user provides a phone number when they pick "phone" as contact method
        $.fn.form.settings.rules.checkContactMethodPreference = function (phoneNumberValue) {
            var $phoneField = $('input[name=phone]', $inquiryForm);
            var contactMethod = $('input[name="contact_method"]:checked', $inquiryForm).val();

            if (contactMethod == 'email') {
                return true;
            } if (contactMethod == 'phone') {
                return !!$phoneField.val();
            }

            return false;
        };

        $('input[name="contact_method"]').on('change', function () {
            var contactMethod = $(this).val();
            var $phoneField = $('input[name=phone]', $inquiryForm);

            if (contactMethod == 'email') {
                $phoneField.removeAttr('required');
                $phoneField.parent('.field').removeClass('required');
            } else {
                $phoneField.attr('required', 1);
                $phoneField.parent('.field').addClass('required');
            }

            // re-validate without submitting
            $inquiryForm.form('is valid');
        });

        $form.form({
            fields: formFields,
            inline: true,
            on: 'blur',
            onSuccess: function (e, fields) {
                e.preventDefault();

                var selectedOptionsString = $(':checked', $form).get().reduce(function (acc, el) {
                    return (acc ? acc + ', ' : '') + $(el).val();
                }, null);

                var leadgenType = $container.data('leadgen-type');

                ga(
                    'send',
                    'event',
                    'Leadgen',
                    'Clicked Get Info Button',
                    classData.providerName
                    + ': '
                    + classData.courseName
                    + ' | '
                    + leadgenType
                    + ' | '
                    + selectedOptionsString,
                    { nonInteraction: false }
                );

                if (leadgenType == 'inquiry' || leadgenType == 'private_info_session') {
                    // The flow is: there are hidden fields in the main form that start as disabled (so semantic doesn't try to validate them)
                    // and empty. If they're empty, we pop the modal, and after the modal is filled out, the hidden fields are activated
                    // and populated with the data from the modal, so everything can be submitted together
                    if (
                        !$('[name=email]', $form).val()
                        || !$('[name=full_name]', $form).val()
                    ) {
                        var $dateSelect = $('[name=meeting_time]', $inquiryForm).prop('disabled', true).hide();

                        $inquiryModal.modal({
                            onVisible: function () {
                                $inquiryForm.form({
                                    fields: formFields,
                                    inline: true,
                                    on: 'blur',
                                    onSuccess: function (e, fields) {
                                        e.preventDefault();

                                        $inquiryModal.modal('hide');

                                        $('[name=email]', $form).prop('disabled', false).val($('[name=email]', $inquiryModal).val());
                                        $('[name=phone]', $form).prop('disabled', false).val($('[name=phone]', $inquiryModal).val());
                                        $('[name=full_name]', $form).prop('disabled', false).val($('[name=full_name]', $inquiryModal).val());
                                        $('[name=meeting_type]', $form).prop('disabled', false).val($('[name=meeting_type]:checked', $inquiryModal).val());
                                        $('[name=contact_method]', $form).prop('disabled', false).val($('[name=contact_method]:checked', $inquiryModal).val());

                                        var finalMeetingTime = $otherDateField.is(':enabled')
                                            ? $otherDateField.val()
                                            : $dateSelect.val();
                                        $('[name=final_meeting_time]', $form)
                                            .prop('disabled', false)
                                            .val(finalMeetingTime);
                                        // Since the hidden fields are populated now, the outer form should be able to get past this block on submit
                                        $form.submit();
                                    },
                                });

                                $dateSelect
                                    .prop('disabled', false)
                                    .show()
                                    .val(outerScheduleValue);
                            },
                        });


                        $inquiryModal.modal('show');
                        return;
                    }
                }

                $form.addClass('loading');
                $.ajax({
                    type: $form.attr('method'),
                    url: $form.attr('action'),
                    data: $form.serialize(),
                    success: function (res) {
                        $form.removeClass('loading');
                        if (res && res.success) {
                            ga(
                                'send',
                                'event',
                                'Leadgen',
                                'Submitted Leadgen Form',
                                classData.providerName + ': ' + classData.courseName + ' | ' + leadgenType,
                                { nonInteraction: false }
                            );

                            $('.booking-menu .item[data-tab=book]', $container).trigger('click');
                            var successText = leadgenType == 'private_info_session'
                                ? 'The class provider will reach out shortly to confirm your info session appointment.'
                                : "You'll receive a follow-up soon!";
                            swal({
                                type: 'success',
                                title: 'Thank you!',
                                text: successText,
                            });

                            // Prevent duplicate submits
                            $(clickedTrigger)
                                .addClass('disabled')
                                .prop('disabled', true)
                                .unbind('click');
                        } else {
                            // If somehow there's a server-side error that the client-side didn't catch, clear out these values
                            // so the user can open the modal again to correct mistakes if necessary
                            if (leadgenType == 'inquiry') {
                                $('[name=contact_method]', $form).prop('disabled', true).val('');
                                $('[name=email]', $form).prop('disabled', true).val('');
                                $('[name=phone]', $form).prop('disabled', true).val('');
                                $('[name=full_name]', $form).prop('disabled', true).val('');
                            }

                            swal(
                                'Oh dear! There seems to be a problem.',
                                (res && res.error) || 'Please refresh the page and try again',
                                'error'
                            );
                        }
                    },
                });
            },
        });
    }

    function attachBuyButtonTracking() {
        // js-school-site-button - providerCourseUrl - Visit School
        // js-learn-more-non-enrollment - !isAcceptingEnrollments - Learn More
        // js-enrollment-button - Book Now (not always set!)
        // js-apply-now-button - isCourseBeautyTreatment - Apply Now
        // js-schedule-visit-button - isCourseBeautyTreatment - Schedule a visit
        // js-inquiry-submit, js-inquiry-modal-submit - Get Info (inquiry) on tab AND modal
        // js-trigger-give-as-gc - Give as Gift
        // js-trigger-inquiry

        $('.js-track-action-click').on('click', function () {
            var $activeElement = $(this);
            var destinationUrl = $activeElement[0].pathname + $activeElement[0].search;
            var buttonText = ($activeElement.val() || $activeElement.text() || 'uncategorized button').trim();
            var action = $(this).data('action') || 'uncategorized button';
            ga(
                'send',
                'event',
                'North Star Metric: Action Clicks',
                'Clicked ' + action,
                classData.providerName + ': ' + classData.courseName + ' | ' + window.location.pathname + ' | ' + buttonText + ' | ' + destinationUrl,
                { nonInteraction: false }
            );
        });
    }

    // support generic "scroll to element" with class & data-target attribute
    // ex: <a href="#" class="js-scroll-to" data-target=".an-el">
    function initScrollTos() {
        $('a.js-scroll-to')
            .unbind('click')
            .on('click', function (e) {
                var $aElement = $(this);
                var eventLabel = $aElement.data('trigger-event-label') || $aElement.data('target');
                var $targetElement = $($aElement.data('target'));

                if ($aElement.attr('href') == '#') {
                    e.preventDefault();
                }

                CH.scrollToElement($targetElement);

                if ($aElement.data('trigger-ga-event')) {
                    ga(
                        'send',
                        'event',
                        'Course Page',
                        'Clicked Scroll To',
                        eventLabel,
                        { nonInteraction: false }
                    );
                }

                // when the target is hidden as an accordion
                // then show the accordion content
                if (
                    CH
                    && CH.isMobile
                    && $targetElement.hasClass('accordion-mobile')
                ) {
                    $targetElement
                        .find('.accordion-content')
                        .slideDown();
                }
            });
    }

    // full page initialization after page has loaded
    $(function () {
        currentSection = section ? classData[section] : false;
        courseId = CH.courseId;

        if (CH.isMobile) {
            initPayPal();
        }
        if (CH.isMosaicPhotoLayout) {
            initMosaicPhotoLayout();
        }
        attachBuyButtonTracking();
        initSidebar();
        initReviews();
        initCourseInfoTabs();
        initAdditionalSections();
        initProviderMoreCourses();
        initGiveAsGiftModal();

        if (CH && CH.titleImagesCount) {
            initCarousel(CH.titleImagesCount);
        }

        if (CH.isNewCourseSectionLayout) {
            initNewSectionLayout();
        }

        // Initialize here cause initNewSectionLayout() instantiates the pagination section portion of the page
        // which could contain "learn more" button
        initLearnMoreButton();
        initScrollTos();
        initCommunityMessages();
        initCoursePageEvents();
        initBookOrLeadgen();

        if (CH && CH.isMobile) {
            require(['ch_accordion'], function (accordions) {
                accordions.init();
            });
        }

        // sold out course behavior
        if (CH.coursePage.isSoldOut) {
            ga(
                'send',
                'event',
                'Sold Out Course Page',
                'Suggestions Displayed',
                CH.coursePage.soldOutSearchSuggestionsTerm + ' - ' + CH.coursePage.soldOutSearchSuggestionsCount,
                { nonInteraction: true }
            );

            const $rootElement = $('#course-sold-out-alternatives');
            CourseRows.initRows($rootElement, {
                isFiltersEnabled: false,
            });

            // hide content and initialize the expander
            const $coursePageContainer = $('#course-page-container');
            // we will "fade out" all course page content below this element
            const $fadeFromElement = $('#course-info-tabs');
            const originalCoursePageContainerHeight = $coursePageContainer.height();

            $coursePageContainer.css({
                overflow: 'hidden',
                position: 'relative',
                height: $fadeFromElement.offset().top,
            });

            const $expanderLink = $('<a/>');
            $expanderLink
                .addClass('course-page-expander-link ui button')
                .html('Show All Course Details')
                .on('click', function () {
                    // we re-set the height to "auto" once all css transitions are complete
                    $coursePageContainer.one('transitionend webkitTransitionEnd oTransitionEnd MSTransitionEnd', function () {
                        $coursePageContainer.css({
                            height: 'auto',
                        });
                    });
                    $coursePageContainer.css({
                        height: originalCoursePageContainerHeight,
                        overflow: 'visible',
                    });
                    $expanderLink.remove();
                    ga(
                        'send',
                        'event',
                        'Sold Out Course Page',
                        'Clicked Expand Course Details',
                        null,
                        { nonInteraction: false }
                    );
                })
                .appendTo($coursePageContainer);

            $('.js-course-sold-out-top-choices-link').on('click', function (e) {
                e.preventDefault();

                ga(
                    'send',
                    'event',
                    'Sold Out Course Page',
                    'Clicked See Suggestions Button',
                    null,
                    { nonInteraction: false }
                );

                CH.scrollToElement($rootElement);
            });

            $('.js-sold-out-see-all-classes-link').on('click', function () {
                ga(
                    'send',
                    'event',
                    'Sold Out Course Page',
                    'Clicked See All Button',
                    null,
                    { nonInteraction: false }
                );
            });
        }
    });
});
